export default __webpack_public_path__ + "static/media/balance-auto-ignore-people.f9f0a924.md";